import { z } from 'zod';

// Validates after the trim/lowercase transforms (unlike top-level z.email(),
// which checks the raw input), using zod's own email pattern.
export const EmailValidationSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(z.regexes.email, 'Invalid email address');
